module.exports = "assets/b4fe7d72e8baf30b6d2219c0fb2e7566.glb";